module.exports = __webpack_public_path__ + "img/institutoAyrtonSenna.64b2e47f.png";